import { cx } from "../../../utils/classNames";
import { scrollToField } from "../performanceUtils";
import ui from "../../../components/ui/ui.module.css";

// List of missing/invalid answers; each one jumps to its field.
const MissingAnswers = ({ errors }) => {
  if (!errors.length) return null;

  return (
    <div className={cx(ui.alert, ui.alertDanger, ui.alertColumn)} role="alert">
      <strong>Please complete the following before submitting:</strong>
      <ul className="mb-0 ps-3">
        {errors.map((error) => (
          <li key={error.message}>
            {error.fieldId ? (
              <button
                type="button"
                className={ui.linkButton}
                onClick={() => scrollToField(error.fieldId)}
              >
                {error.message}
              </button>
            ) : (
              error.message
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MissingAnswers;
